import serviceOne from '../images/serviceBgOne.jpg';
import serviceTwo from '../images/servicesBgTwo.jpg';

export const allServices = [
  {
    id: 1,
    image: serviceOne,
    desc: 'for Private',
    title: 'CapEx Model',
    text:
      'With the CapEx  model, the entire investment comes from the roof owner either from his own source of from capital market. Roof owner owns the equipment once it has been paid off and get free electricity after 10 years.',
  },
  {
    id: 2,
    image: serviceTwo,
    desc: 'for Commercial',
    title: 'OpEx Model',
    text:
      'In this model as there is zero investment upfront, the roof owner ends up paying a little higher than the CapEx model. No financial risk to deploy green energy due to market change or technology innovation. It is paid in annual installments.  Service provider ensures smooth maintenance and good performance for 20 years.',
  },
];

export const otherTexts = {
  facts:
    'Explore the map and view all our projects around the country and click on any project to see the details of that project.',

  plan:
    'All functions including supply chain, value chain, project scheduling, manufacturing, services and spares, technology, R&D, etc. are integrated to give a complete solutions package.',
};
